import { render, staticRenderFns } from "./DataCardSection.vue?vue&type=template&id=66447dd1"
import script from "./DataCardSection.vue?vue&type=script&lang=js"
export * from "./DataCardSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports